export const notifications = {
  successDataUpdate: 'I dati vengono modificati correttamente.',
  errorOnDataUpdate:
    'Quando i dati vengono modificati, si è verificato un errore.',
  waitResponseIn24Hours: 'Aspettatevi la risposta al tuo invito entro 72 ore.',
  workItemIsCanceled: "L'invito è stato ritirato",
  notificationDeleted: 'La notifica viene eliminata',
  noNotifications: 'Non hai notifiche',
  workInviteRejected: "L'invito viene respinto",
  workStartOnArtistArrivalConfirm:
    'Il lavoro inizierà dal momento in cui il club conferma la tua presenza sul posto di lavoro.',
  giveResponseFormWorkItem:
    "Dai una risposta all'invito entro 72 ore. Dopo 72 ore, l'invito verrà eliminato.",
  generalError: 'Qualcosa è andato storto, prova più tardi.',
  passwordReseted: 'La password viene eliminata',
  languageSwitched: 'La lingua è cambiata',
  invitationExpired: "L'invito è scaduto",
  linkIsCopied: 'Il collegamento viene copiato',
  accountIsVisible: "L'account verrà mostrato nella ricerca",
  hiringEnabled: 'Un set di artisti è aperto',
  hiringDisabled: 'Il set di artisti è chiuso',
  rejectedForReason: 'Otclone a causa di __var_0__',
  profileDeleted: 'Il profilo viene rimosso',
  accountHiddenFromSearch:
    "L'account è nascosto e non è più visualizzato nella ricerca di artisti",
  registerRequestSended: 'La richiesta di registrazione è stata inviata',
  notFoundNotifications: 'Non hai notifiche',
  lastWorkDaySeted: "È stata impostata l'ultima data di lavoro"
};
